import {Spreadsheet} from '@/components/spreadsheet/spreadsheet';
import moment from 'moment';
import * as _ from 'lodash';

export class AnalysisBreakDownPmaDetail extends Spreadsheet {
  name: string = 'break_down_detailed';
  source: any;

  getPeriod() {
    const start = new Date(parseInt(this.source.per_ini.substring(0, 4)), parseInt(this.source.per_ini.substring(4, 6)) - 1, 1);
    const end = new Date(parseInt(this.source.per_fim.substring(0, 4)), parseInt(this.source.per_fim.substring(4, 6)) - 1, 1);

    return {
      start: moment(start).format('MM/YYYY'),
      end: moment(end).format('MM/YYYY')
    };
  }

  mount(dataSource: any[]) {

    if (_.size(dataSource) === 0) return;

    this.source = dataSource[0];

    const sections: Array<any> = [
      {key: 'locale', text: 'LOCALE', index: 0},
      {key: 'Registration', text: 'RETAIL REGISTRATION', index: 4},
      {key: 'sales', text: 'SALES', index: 7},
      {key: 'outlets', text: 'OUTLETS', index: 9}
    ];

    const sectionColumns: any = {
      locale: [
        {key: 'cod_area_virtual', text: 'OPERATIONAL AREA CODE', textAlign: 'center'},
        {key: 'area_virtual', text: 'OPERATIONAL AREA', textAlign: 'center'},
        {key: 'cd_pma', text: 'PMA CODE', textAlign: 'center'},
        {key: 'nm_pma', text: 'PMA', textAlign: 'center'},
      ],
      Registration: [
        {key: 'qt_emc_ind', text: 'INDUSTRY RETAIL REGISTRATION', textAlign: 'center'},
        {key: 'qt_emc_cli', text: 'BRAND RETAIL REGISTRATION', textAlign: 'center'},
        {key: 'ms_emc_cli', text: 'MKT SHARE REGISTRATION', textAlign: 'center', format: '#0.00%'}
      ],
      sales: [
        {key: 'vnd_ind', text: 'INDUSTRY SALES', textAlign: 'center'},
        {key: 'vnd_cli', text: 'BRAND SALES', textAlign: 'center'}
      ],
      outlets: [
        {key: 'qt_lja_ind', text: 'OUTLETS (ALL BRANDS)', textAlign: 'center'},
        {key: 'qt_lja_cli', text: 'OUTLETS (BRAND)', textAlign: 'center'}
      ]
    };

    const sectionColumnsDateTime: any = {
      locale: [{key: '', text: ''}],
      Registration: [],
      basket: [{key: 'basket', text: `${this.getPeriod().start} TO ${this.getPeriod().end}`}],
      sales: [],
      outlets: [],
    };

    const baseStyle: any = {
      textAlign: 'left',
      fontSize: 9,
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseHeaderStyle: any = {
      color: '#212121',
      fontSize: 9,
      bold: true,
      textAlign: 'center',
      verticalAlign: 'center',
      fontFamily: 'Calibri'
    };

    const baseColorStyle: any = {
      locale: '#bdbdbd',
      Registration: '#90a4ae',
      basket: '#bdbdbd',
      sales: '#90a4ae',
      outlets: '#e57373',
      grey: '#d1d1d1',
      greyDarken: '#c1c1c1',
      updated: '#81c784',
      yellow: '#ffb74d'
    };

    const baseBorderColorStyle: any = {
      locale: '#e0e0e0',
      Registration: '#cfd8dc',
      basket: '#cfd8dc',
      sales: '#cfd8dc',
      outlets: '#ffcdd2',
      yellow: '#ffe0b2'
    };

    const baseBackgroundColorStyle: any = {
      locale: '#fafafa',
      Registration: '#f9fafb',
      basket: '#fff5f6',
      sales: '#f9fafb',
      outlets: '#fff5f6',
      yellow: '#fffbf5'
    };

    const headerStyle = _.reduce(
        baseColorStyle,
        (acc: any, val: string, key: string) => {
          acc[key] = _.assign({}, baseHeaderStyle, {background: baseColorStyle[key]});
          return acc;
        },
        {}
    );

    const getCellStyle = (key: any) => {
      return _.assign({}, baseStyle, {
        textAlign: 'center',
        background: baseBackgroundColorStyle[key],
        borderLeft: {color: baseBorderColorStyle[key], size: 1},
        borderRight: {color: baseBorderColorStyle[key], size: 1},
        borderTop: {color: baseBorderColorStyle[key], size: 1},
        borderBottom: {color: baseBorderColorStyle[key], size: 1}
      });
    };

    this.workbookOptions = {
      sheets: {
        name: 'PMA',
        frozenColumns: 2,
        frozenRows: 3,
        filter: {
          ref: `A3:K3`,
          columns: []
        },
        rows: [
          {
            cells: [
              ..._.map(sections, (section: any) =>
                  _.assign({}, headerStyle[section.key], {
                    value: section.text,
                    index: section.index,
                    borderLeft: {color: baseBorderColorStyle[section.key], size: 1},
                    borderRight: {color: baseBorderColorStyle[section.key], size: 1}
                  })
              )
            ]
          },
          {
            cells: [
              ..._(sectionColumnsDateTime)
                  .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                          _.assign({}, getCellStyle(cell.color || key), {
                            value: cell.text,
                            bold: true,
                            index: cell.index,
                            background: baseColorStyle.grey,
                            borderLeft: {color: baseBorderColorStyle.locale, size: 1},
                            borderRight: {color: baseBorderColorStyle.locale, size: 1},
                            borderTop: {color: baseBorderColorStyle.locale, size: 1},
                            borderBottom: {color: baseBorderColorStyle.locale, size: 1}
                          })
                      )
                  )
                  .flatten()
                  .value()
            ]
          },
          {
            height: 80,
            cells: [
              ..._(sectionColumns)
                  .map((columns: any, key: any) =>
                      _.map(columns, (cell: any) =>
                          _.assign({}, headerStyle[cell.color || key], {
                            value: cell.text,
                            wrap: true,
                            borderLeft: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderRight: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderTop: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderBottom: {color: baseBorderColorStyle[cell.color || key], size: 1}
                          })
                      )
                  )
                  .flatten()
                  .value()
            ]
          },
          ..._.map(dataSource, d => {
            return ({
              cells: [
                ..._(sectionColumns)
                    .map((columns, key) =>
                        _.map(columns, (cell, k) => {
                          return _.assign({}, getCellStyle(d[cell.key] || key), {
                            value: d[cell.key],
                            textAlign: cell.textAlign,
                            format: cell.format,
                            borderLeft: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderRight: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderTop: {color: baseBorderColorStyle[cell.color || key], size: 1},
                            borderBottom: {color: baseBorderColorStyle[cell.color || key], size: 1}
                          });
                        }))
                    .flatten()
                    .value()
              ]

            });
          })
        ],
        columns: [
          {index: 0, width: 100},
          {index: 1, width: 160},
          {index: 2, width: 80},
          {index: 3, width: 160},
          {index: 4, width: 200},
          {index: 5, width: 120},
          {index: 6, width: 160},
          {index: 7, width: 180},
          {index: 8, width: 120},
          {index: 9, width: 160},
          {index: 10, width: 100},
          {index: 11, width: 120},
          {index: 12, width: 100},
          {index: 13, width: 100},
          {index: 14, width: 100},
          {index: 15, width: 100},
          {index: 16, width: 100},
          {index: 17, width: 100},
        ],
        showGridLines: false,
        mergedCells: [
          'A1:D1',
          'E1:G1',
          'H1:I1',
          'J1:K1',
          'A2:D2',
          'E2:K2',
        ]
      } as any
    };

    return this;
  }
}
